import React, { useState } from 'react'
import * as api from '../../../lib/api'
import { supabase } from '../../../lib/supabase'
import { useToast } from '../../../contexts/ToastContext'
import Modal from '../../../components/Modal'
import CustomSelect from '../../../components/CustomSelect/CustomSelect'

export default function AccountSettings({ profile, user }) {
  const toast = useToast()

  // Аккаунт (модалки)
  const [editingField, setEditingField] = useState(null) // 'login', 'email', 'password', null
  const [accountInputs, setAccountInputs] = useState({ login: '', email: '', password: '', currentPassword: '' })
  const [accountSaving, setAccountSaving] = useState(false)

  // PIN-код и секретный вопрос
  const [pinSetupMode, setPinSetupMode] = useState(null) // 'set', 'change', 'remove', null
  const [pinInputs, setPinInputs] = useState({ pin: '', pinConfirm: '', currentPin: '' })
  const [pinSaving, setPinSaving] = useState(false)
  const [secretSetupMode, setSecretSetupMode] = useState(false)
  const [secretInputs, setSecretInputs] = useState({ question: '', answer: '' })
  const [secretSaving, setSecretSaving] = useState(false)

  const handleAccountSave = async (e) => {
    e.preventDefault()
    setAccountSaving(true)
    try {
      if (editingField === 'login') {
        const loginStr = accountInputs.login.trim()
        if (loginStr.length < 3) throw new Error('Логин слишком короткий')
        await api.updateProfile(profile.id, { login: loginStr })
        toast.success('Логин успешно изменен!')
      } 
      else if (editingField === 'email') {
        await api.updateProfile(profile.id, { email: accountInputs.email })
        toast.success('Email обновлен!')
      }
      else if (editingField === 'password') {
        if (accountInputs.password.length < 6) throw new Error('Пароль слишком короткий')
        const token = localStorage.getItem('token')
        const API_URL = import.meta.env.VITE_API_URL || '/api'
        const res = await fetch(`${API_URL}/auth/password`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': 'Bearer ' + token } : {})
          },
          body: JSON.stringify({
            currentPassword: accountInputs.currentPassword,
            newPassword: accountInputs.password
          })
        })
        const data = await res.json()
        if (!res.ok) throw new Error(data.error || 'Ошибка смены пароля')
        toast.success('Пароль успешно изменен!')
      }
      setEditingField(null)
      setTimeout(() => window.location.reload(), 1500)
      setAccountInputs({ login: '', email: '', password: '', currentPassword: '' })
    } catch (err) {
      toast.error(err.message)
    } finally {
      setAccountSaving(false)
    }
  }

  return (
    <div className="settings-section animate-fade-in">
      <h3 className="settings-section-title">Безопасность и вход</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px', background: 'var(--surface)', borderRadius: '12px', border: '1px solid var(--surface-border)' }}>
          <div>
            <div style={{ fontSize: '12px', color: 'var(--text-secondary)', marginBottom: '4px' }}>Логин</div>
            <div style={{ fontWeight: 600 }}>{profile?.login || 'Не задан'}</div>
          </div>
          <button className="btn btn-outline btn-sm" onClick={() => { setEditingField('login'); setAccountInputs({ ...accountInputs, login: profile?.login || '' }) }}>
            Изменить
          </button>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px', background: 'var(--surface)', borderRadius: '12px', border: '1px solid var(--surface-border)' }}>
          <div>
            <div style={{ fontSize: '12px', color: 'var(--text-secondary)', marginBottom: '4px' }}>Почта (Email)</div>
            <div style={{ fontWeight: 600 }}>{user?.email}</div>
          </div>
          <button className="btn btn-outline btn-sm" onClick={() => { setEditingField('email'); setAccountInputs({ ...accountInputs, email: user?.email || '' }) }}>
            Изменить
          </button>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px', background: 'var(--surface)', borderRadius: '12px', border: '1px solid var(--surface-border)' }}>
          <div>
            <div style={{ fontSize: '12px', color: 'var(--text-secondary)', marginBottom: '4px' }}>Пароль</div>
            <div style={{ fontWeight: 600 }}>********</div>
          </div>
          <button className="btn btn-outline btn-sm" onClick={() => { setEditingField('password'); setAccountInputs({ ...accountInputs, password: '', currentPassword: '' }) }}>
            Изменить
          </button>
        </div>

        {/* PIN-код и Секретный вопрос */}
        <div style={{ marginTop: '24px', paddingTop: '20px', borderTop: '2px solid var(--surface-border)' }}>
          <h3 className="settings-section-title" style={{ fontSize: '15px', marginBottom: '16px' }}>Защита на общем ПК</h3>
          <div style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '16px', background: 'var(--surface-hover)', padding: '12px', borderRadius: '10px', lineHeight: '1.5' }}>
            Если вы работаете на общем компьютере, рекомендуем настроить PIN-код. Он защитит ваш аккаунт от доступа коллег.
          </div>

          {/* PIN-код */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px', background: 'var(--surface)', borderRadius: '12px', border: '1px solid var(--surface-border)', marginBottom: '12px' }}>
            <div>
              <div style={{ fontSize: '12px', color: 'var(--text-secondary)', marginBottom: '4px' }}>PIN-код быстрого входа</div>
              <div style={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
                {profile?.pin_hash ? (
                  <span style={{ color: 'var(--success)' }}>Настроен</span>
                ) : (
                  <span style={{ color: 'var(--text-tertiary)' }}>Не настроен</span>
                )}
              </div>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              {profile?.pin_hash ? (
                <>
                  <button className="btn btn-outline btn-sm" onClick={() => { setPinSetupMode('change'); setPinInputs({ pin: '', pinConfirm: '', currentPin: '' }) }}>Сменить</button>
                  <button className="btn btn-ghost btn-sm" style={{ color: 'var(--danger)' }} onClick={() => setPinSetupMode('remove')}>Убрать</button>
                </>
              ) : (
                <button className="btn btn-primary btn-sm" onClick={() => { setPinSetupMode('set'); setPinInputs({ pin: '', pinConfirm: '', currentPin: '' }) }}>Настроить</button>
              )}
            </div>
          </div>

          {/* PIN Setup/Change form */}
          {(pinSetupMode === 'set' || pinSetupMode === 'change') && (
            <div className="animate-fade-in" style={{ padding: '16px', background: 'var(--surface-hover)', borderRadius: '12px', marginBottom: '12px' }}>
              <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '12px' }}>
                {pinSetupMode === 'set' ? 'Создание PIN-кода' : 'Смена PIN-кода'}
              </div>
              {pinSetupMode === 'change' && (
                <div className="input-group" style={{ marginBottom: '12px' }}>
                  <label>Текущий PIN</label>
                  <input className="input" type="password" inputMode="numeric" maxLength={4} pattern="[0-9]{4}" autoComplete="off" name={'cp_' + Date.now()} placeholder="● ● ● ●" value={pinInputs.currentPin} onChange={e => setPinInputs({...pinInputs, currentPin: e.target.value.replace(/\D/g, '').slice(0, 4)})} style={{ letterSpacing: '8px', textAlign: 'center', fontSize: '20px' }} />
                </div>
              )}
              <div className="input-group" style={{ marginBottom: '12px' }}>
                <label>Новый PIN (4 цифры)</label>
                <input className="input" type="password" inputMode="numeric" maxLength={4} pattern="[0-9]{4}" autoComplete="off" name={'np_' + Date.now()} placeholder="● ● ● ●" value={pinInputs.pin} onChange={e => setPinInputs({...pinInputs, pin: e.target.value.replace(/\D/g, '').slice(0, 4)})} style={{ letterSpacing: '8px', textAlign: 'center', fontSize: '20px' }} />
              </div>
              <div className="input-group" style={{ marginBottom: '16px' }}>
                <label>Повторите PIN</label>
                <input className="input" type="password" inputMode="numeric" maxLength={4} pattern="[0-9]{4}" autoComplete="off" name={'rp_' + Date.now()} placeholder="● ● ● ●" value={pinInputs.pinConfirm} onChange={e => setPinInputs({...pinInputs, pinConfirm: e.target.value.replace(/\D/g, '').slice(0, 4)})} style={{ letterSpacing: '8px', textAlign: 'center', fontSize: '20px' }} />
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button className="btn btn-ghost" onClick={() => setPinSetupMode(null)}>Отмена</button>
                <button className="btn btn-primary" disabled={pinSaving || pinInputs.pin.length !== 4 || pinInputs.pin !== pinInputs.pinConfirm || (pinSetupMode === 'change' && pinInputs.currentPin.length !== 4)} onClick={async () => {
                  setPinSaving(true)
                  try {
                    if (pinSetupMode === 'change') {
                      const check = await api.verifyPin(profile.id, pinInputs.currentPin)
                      if (!check.success) throw new Error(check.locked ? 'PIN заблокирован. Попробуйте позже.' : 'Неверный текущий PIN')
                    }
                    await api.setPin(profile.id, pinInputs.pin)
                    profile.pin_hash = 'set'
                    toast.success('PIN-код ' + (pinSetupMode === 'set' ? 'установлен' : 'изменён') + '!')
                    setPinSetupMode(null)
                  } catch (err) { toast.error(err.message) } finally { setPinSaving(false) }
                }}>
                  {pinSaving ? <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{animation:'spin 1s linear infinite'}}><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg> : pinSetupMode === 'set' ? 'Установить PIN' : 'Сменить PIN'}
                </button>
              </div>
            </div>
          )}

          {/* PIN Remove confirm */}
          {pinSetupMode === 'remove' && (
            <div className="animate-fade-in" style={{ padding: '16px', background: 'rgba(239, 68, 68, 0.05)', borderRadius: '12px', marginBottom: '12px', border: '1px solid rgba(239, 68, 68, 0.2)' }}>
              <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '8px', color: 'var(--danger)', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                  <line x1="12" y1="9" x2="12" y2="13"/>
                  <line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg> Удалить PIN-код?
              </div>
              <div style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '12px' }}>Ваш аккаунт будет менее защищён на общем ПК.</div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button className="btn btn-ghost" onClick={() => setPinSetupMode(null)}>Отмена</button>
                <button className="btn btn-danger" disabled={pinSaving} onClick={async () => {
                  setPinSaving(true)
                  try {
                    await api.removePin(profile.id)
                    profile.pin_hash = null
                    toast.success('PIN-код удалён')
                    setPinSetupMode(null)
                  } catch (err) { toast.error(err.message) } finally { setPinSaving(false) }
                }}>
                  {pinSaving ? <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{animation:'spin 1s linear infinite'}}><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg> : 'Удалить PIN'}
                </button>
              </div>
            </div>
          )}

          {/* Секретный вопрос */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px', background: 'var(--surface)', borderRadius: '12px', border: '1px solid var(--surface-border)' }}>
            <div>
              <div style={{ fontSize: '12px', color: 'var(--text-secondary)', marginBottom: '4px' }}>Секретный вопрос</div>
              <div style={{ fontWeight: 600 }}>
                {profile?.secret_question ? (
                  <span style={{ color: 'var(--success)' }}>{profile.secret_question}</span>
                ) : (
                  <span style={{ color: 'var(--text-tertiary)' }}>Не задан</span>
                )}
              </div>
            </div>
            <button className="btn btn-outline btn-sm" onClick={() => { setSecretSetupMode(true); setSecretInputs({ question: profile?.secret_question || '', answer: '' }) }}>
              {profile?.secret_question ? 'Изменить' : 'Настроить'}
            </button>
          </div>

          {/* Secret Question setup */}
          {secretSetupMode && (
            <div className="animate-fade-in" style={{ padding: '16px', background: 'var(--surface-hover)', borderRadius: '12px', marginTop: '12px' }}>
              <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '12px' }}>Секретный вопрос</div>
              <div style={{ fontSize: '12px', color: 'var(--text-secondary)', marginBottom: '12px' }}>Нужен для восстановления PIN-кода, если забудете.</div>
              <div className="input-group" style={{ marginBottom: '12px' }}>
                <CustomSelect
                  label="Выберите вопрос"
                  value={secretInputs.question}
                  onChange={val => setSecretInputs({...secretInputs, question: val})}
                  placeholder="— Выберите —"
                  options={[
                    { value: 'Кличка вашего первого питомца?', label: 'Кличка вашего первого питомца?' },
                    { value: 'Город, в котором вы родились?', label: 'Город, в котором вы родились?' },
                    { value: 'Любимое блюдо?', label: 'Любимое блюдо?' },
                    { value: 'Имя лучшего друга детства?', label: 'Имя лучшего друга детства?' },
                    { value: 'Название вашей первой школы?', label: 'Название вашей первой школы?' },
                    { value: 'Любимый фильм?', label: 'Любимый фильм?' },
                  ]}
                />
              </div>
              <div className="input-group" style={{ marginBottom: '16px' }}>
                <label>Ответ</label>
                <input className="input" type="text" autoComplete="off" name={'sa_' + Date.now()} required value={secretInputs.answer} onChange={e => setSecretInputs({...secretInputs, answer: e.target.value})} placeholder="Ваш ответ..." />
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button className="btn btn-ghost" onClick={() => setSecretSetupMode(false)}>Отмена</button>
                <button className="btn btn-primary" disabled={secretSaving || !secretInputs.question || !secretInputs.answer.trim()} onClick={async () => {
                  setSecretSaving(true)
                  try {
                    await api.setSecretQuestion(profile.id, secretInputs.question, secretInputs.answer)
                    profile.secret_question = secretInputs.question
                    profile.secret_answer_hash = 'set'
                    toast.success('Секретный вопрос сохранён!')
                    setSecretSetupMode(false)
                  } catch (err) { toast.error(err.message) } finally { setSecretSaving(false) }
                }}>
                  {secretSaving ? <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{animation:'spin 1s linear infinite'}}><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg> : 'Сохранить'}
                </button>
              </div>
            </div>
          )}
        </div>

      </div>

      {/* Editing Modal */}
      {editingField && (
        <Modal isOpen={true} title={editingField === 'login' ? 'Изменить логин' : editingField === 'email' ? 'Изменить Email' : 'Изменить пароль'} onClose={() => setEditingField(null)}>
          <form onSubmit={handleAccountSave} style={{ display: 'flex', flexDirection: 'column', gap: '16px', minWidth: '300px' }}>
            
            {editingField === 'login' && (
              <div className="input-group">
                <label>Новый логин</label>
                <input className="input" type="text" required value={accountInputs.login} onChange={e => setAccountInputs({...accountInputs, login: e.target.value})} placeholder="ivan_petrov" />
              </div>
            )}

            {editingField === 'email' && (
              <>
                <div style={{ fontSize: '13px', color: 'var(--text-secondary)', background: 'var(--surface-hover)', padding: '12px', borderRadius: '8px' }}>
                  На новый адрес будет отправлено письмо со ссылкой для подтверждения. До перехода по ссылке почта не изменится.
                </div>
                <div className="input-group">
                  <label>Новый Email</label>
                  <input className="input" type="email" required value={accountInputs.email} onChange={e => setAccountInputs({...accountInputs, email: e.target.value})} />
                </div>
              </>
            )}

            {editingField === 'password' && (
              <>
                <div className="input-group">
                  <label>Текущий пароль</label>
                  <input className="input" type="password" required value={accountInputs.currentPassword} onChange={e => setAccountInputs({...accountInputs, currentPassword: e.target.value})} />
                </div>
                <div className="input-group">
                  <label>Новый пароль</label>
                  <input className="input" type="password" required minLength={6} value={accountInputs.password} onChange={e => setAccountInputs({...accountInputs, password: e.target.value})} />
                </div>
              </>
            )}

            <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
              <button type="button" className="btn btn-ghost" onClick={() => setEditingField(null)}>Отмена</button>
              <button type="submit" className="btn btn-primary" style={{ flex: 1 }} disabled={accountSaving}>
                {accountSaving ? 'Сохранение...' : 'Сохранить'}
              </button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  )
}
